import {
  faArrowRightToBracket,
  faGear
} from '@awesome.me/kit-5de77b2c02/icons/classic/regular'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'
import { useUserSession } from '../../../routing/SessionContext'
import styles from './menus.module.scss'

const UserMenu: FC = () => {
  const { handleSignout, editProfile } = useUserSession()
  return (
    <>
      <div className={styles.menuSection}>User</div>
      <div className={styles.optionsContainer}>
        <div className={styles.dropdownButton} onClick={editProfile}>
          <FontAwesomeIcon icon={faGear} />
          <span>Manage Profile</span>
        </div>
        <div className={styles.dropdownButton} onClick={handleSignout}>
          <FontAwesomeIcon icon={faArrowRightToBracket} />
          <span>Sign Out</span>
        </div>
      </div>
    </>
  )
}

export default UserMenu
